export const UPLOAD_ORDER_MUTATION_KEY = ['ordersRecognition', 'uploadOrder'] as const;
export const ORDERS_RECOGNITION_LIST = ['ordersRecognition', 'list'];
export const ORDERS_RECOGNITION_SEARCH = ['ordersRecognition', 'search'];
